// Vendor Libs
import {omit} from 'lodash';

// Private
const initialOverlayState = {};

const actions = {
    OVERLAY_OPEN: (state, {config}) => ({...state, [config.id]: config}),

    OVERLAY_CLOSE: (state, {id}) => omit(state, [id]),

    OVERLAY_CLOSE_ALL: () => initialOverlayState,

    AUTHENTICATE_LOGOUT: () => initialOverlayState,

    LAYOUT_UPDATE: () => initialOverlayState,
};

const reducer = (state = initialOverlayState, action) =>
    (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
